import { ReactNode } from "react";

import { IconButton, IconButtonProps, alpha, styled } from "@mui/material";

type StyledFormattingButtonProps = {
	isActive?: boolean;
};

const StyledFormattingButton = styled(IconButton, {
	shouldForwardProp: (prop) => prop !== "isActive",
})<StyledFormattingButtonProps>(({ theme, isActive }) => {
	const primary = theme.palette.primary.main;
	return {
		backgroundColor: isActive
			? alpha(primary, theme.palette.mode === "dark" ? 0.25 : 0.12)
			: "transparent",
		color: isActive ? primary : theme.palette.text.secondary,
		borderRadius: "5px",
		width: "25px",
		height: "25px",
		marginRight: "5px",
		"&:hover:not(.Mui-disabled)": {
			backgroundColor: isActive
				? alpha(primary, theme.palette.mode === "dark" ? 0.35 : 0.2)
				: theme.palette.action.hover,
			color: isActive ? primary : theme.palette.text.primary,
		},
		"&.Mui-disabled": {
			color: theme.palette.action.disabled,
			backgroundColor: "transparent",
		},
	};
});

type Props = {
	children: ReactNode;
	isActive?: boolean;
};

export const FormattingButton = (props: Props & IconButtonProps) => {
	const { children, ...rest } = props;
	return <StyledFormattingButton {...rest}>{children}</StyledFormattingButton>;
};
